import { ComponentStyleProps } from "../../../../../lib/styles/props/component-style-props";
import {
  CMButtonSearchConditionMaster,
  SearchDropdownDisplayValue,
} from "@pscsrvlab/psc-react-components";
import React, { useCallback, useMemo } from "react";
import { hasValue } from "../../../../../lib/util/common-util";
import log from "loglevel";
import { stockRequestApi } from "../../../../../store/api/enhanced-api";
import { errorMessageOf } from "../../../../../lib/util/error-util";
import useCustomToast from "../../../../../hooks/use-custom-toast";
import { useAppTranslation } from "../../../../../hooks/use-app-translation";

export type ButtonSearchConditionInstitutionProps = {
  label: string;
  placeholder?: string;

  /**
   * 値。機関ID。
   */
  value?: number | null;

  hideClearButton?: boolean;

  onChange?: (value: number | null) => void;
} & ComponentStyleProps;
export const ButtonSearchConditionInstitution = ({
  label,
  placeholder = "",

  value = null,

  hideClearButton = false,

  onChange,

  sx,
  ...rest
}: ButtonSearchConditionInstitutionProps) => {
  const { t } = useAppTranslation();
  const { errorToast } = useCustomToast();

  const labelSubmit = useMemo(() => t("btn.確定ボタン"), [t]);
  const labelClear = useMemo(() => t("btn.クリアボタン"), [t]);

  const [triggerListInstitutionQuery] =
    stockRequestApi.useLazyListInstitutionQuery();

  const [triggerGetInstitutionQuery] =
    stockRequestApi.useLazyGetInstitutionQuery();

  const toDisplayValue: (
    value: number,
  ) => Promise<SearchDropdownDisplayValue> = async (value) => {
    try {
      const institution = await triggerGetInstitutionQuery({
        institutionId: value,
      }).unwrap();
      return {
        headingLabel: institution.displayInstitutionId,
        mainLabel: institution.name ?? "",
      };
    } catch (e) {
      log.error(errorMessageOf(e));
      return { headingLabel: undefined, mainLabel: "" };
    }
  };

  const handleSearch: (text: string) => Promise<number[]> = useCallback(
    async (text: string) => {
      try {
        const selectableInstitutions: number[] = (
          await triggerListInstitutionQuery({
            institutionName: text,
          }).unwrap()
        )
          .map((v) => v?.id)
          .filter(hasValue);
        return selectableInstitutions;
      } catch (e) {
        log.error(errorMessageOf(e));
        errorToast(t("mes.汎用エラーメッセージ"));
        return [];
      }
    },
    [errorToast, t, triggerListInstitutionQuery],
  );

  const capitalizedLabel = label;

  return (
    <CMButtonSearchConditionMaster<number>
      label={capitalizedLabel}
      placeholder={placeholder}
      menuShowMaxCount={30}
      value={value}
      hideClearButton={hideClearButton}
      labelSubmit={labelSubmit}
      labelClear={labelClear}
      searchResultNone={t("mes.該当機関なしメッセージ")}
      toDisplayValue={toDisplayValue}
      onSearch={handleSearch}
      onChange={onChange}
      sx={sx}
      {...rest}
    />
  );
};
